module.exports = __webpack_public_path__ + "img/PP_Sword_0018.b902dbfb.png";